<section
  class="mbs-wizard_form"
  [formGroup]="stepForm">
  <div class="mbs-wizard_form-content">
    @if (isRDMode && importedPlanChanged) {
      <mbs-alert
        [attr.data-e2e]="elementsSelector.name.configNotSupportedAlert"
        [icon]="true"
        [type]="mbsPopupType.warning">
        {{ 'wizards:whereBackup.where_backup_config_not_supported' | i18next }}
      </mbs-alert>
    }

    @if (whereBackupStepLogic.notExistRepositoryForCorrectStepState) {
      <mbs-alert
        [attr.data-e2e]="elementsSelector.name.noStoragesAlert"
        [icon]="true"
        [type]="mbsPopupType.warning">
        {{ 'wizards:whereBackup.where_backup_no_storages' | i18next }}
      </mbs-alert>
    }

    @if (whereBackupStepLogic.needShowRadioButtons) {
      <mbs-form-group [attr.data-e2e]="elementsSelector.name.radioButtonsBox">
        <mbs-radio
          formControlName="IsHybridBackup"
          name="backupType"
          [id]="'local-or-cloud-radio'"
          [label]="'wizards:local_or_cloud' | i18next"
          [subtitle]="'wizards:local_or_cloud_subtitle' | i18next"
          [subtitleOutside]="false"
          [value]="false"
          (change)="whereBackupStepLogic.isHybridBackupChangeHandler($event)"></mbs-radio>
        <mbs-radio
          formControlName="IsHybridBackup"
          name="backupType"
          [id]="'hybrid-radio'"
          [label]="'wizards:hybrid_label' | i18next"
          [subtitle]="'wizards:hybrid_subtitle' | i18next"
          [subtitleOutside]="false"
          [value]="true"
          (change)="whereBackupStepLogic.isHybridBackupChangeHandler($event)"></mbs-radio>
      </mbs-form-group>
    }

    @if (whereBackupStepLogic.loadingTableDataForLocalOrCloudTable) {
      <mbs-loader [attr.data-e2e]="elementsSelector.name.loaderItem"></mbs-loader>
    }

    @if (whereBackupStepLogic.nbfWithHybrid) {
      @if (stepForm.get('IsHybridBackup').value && whereBackupStepLogic.canBeHybrid) {
        <mbs-form-group>
          <div class="mbs-form_label">
            {{ 'wizards:local_storage' | i18next }}
          </div>

          @if (whereBackupStepLogic.LocalStorages.length === 0) {
            <ng-container>
              <mbs-alert
                class="mt-3"
                [attr.data-e2e]="elementsSelector.name.notLocalStorageAlert"
                [icon]="true"
                [type]="mbsPopupType.warning">
                {{ 'wizards:not_local_storage' | i18next }} <br />
                {{ whereBackupStepLogic.notLocalStorageTexts[0] }}
                <mbs-button
                  [isCtrl]="true"
                  (click)="whereBackupStepLogic.switchToLocalOrCloudOption($event)">
                  {{ whereBackupStepLogic.notLocalStorageTexts[1] }}
                </mbs-button>
                {{ whereBackupStepLogic.notLocalStorageTexts[2] }}
              </mbs-alert>
            </ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="localStorageTable"></ng-container>
          }

          <ng-template #localStorageTable>
            <mbs-where-backup-step-storage-list
              [attr.data-e2e]="elementsSelector.name.listSelectLocal"
              [id]="elementsSelector.id.listLocalStorages"
              [invalid]="isNotValidHybridTable && stepForm.get('HybridID').touched"
              [maxHeight]="'193px'"
              [selectedStorages]="whereBackupStepLogic.selectedLocalStorages"
              [storages]="whereBackupStepLogic.LocalStorages"
              (changeSelected)="changeSelectedHandler($event, false)"
              (rowClick)="clickHandler()"></mbs-where-backup-step-storage-list>
          </ng-template>
        </mbs-form-group>
      }

      @if (!whereBackupStepLogic.loadingTableDataForLocalOrCloudTable && !whereBackupStepLogic.notExistRepositoryForCorrectStepState) {
        <mbs-form-group>
          <div class="mbs-form_label">
            {{ (isConsistencyCheck ? 'wizards:localOrCloudDestination' : 'wizards:local_or_cloud_storage') | i18next }}
          </div>

          <mbs-where-backup-step-storage-list
            [attr.data-e2e]="elementsSelector.name.listSelectLocalOrCloud"
            [disableRowTooltip]="isConsistencyCheck ? whereBackupStepLogic.disabledRowText : ''"
            [id]="elementsSelector.id.listLocalOrCloudStorages"
            [invalid]="isNotValidFirstTable && stepForm.get('ConnectionID').touched"
            [maxHeight]="secondTableMaxHeight"
            [selectedStorages]="whereBackupStepLogic.selectedMixStorages"
            [storages]="whereBackupStepLogic.MixStorages"
            (changeSelected)="changeSelectedHandler($event)"
            (rowClick)="clickHandler()"></mbs-where-backup-step-storage-list>
        </mbs-form-group>
      }
    } @else {
      @if (!whereBackupStepLogic.loadingTableDataForLocalOrCloudTable && !whereBackupStepLogic.notExistRepositoryForCorrectStepState) {
        <mbs-form-group>
          <div class="mbs-form_label">
            {{ (isConsistencyCheck ? 'wizards:localOrCloudDestination' : 'wizards:local_or_cloud_storage') | i18next }}
          </div>

          <mbs-where-backup-step-storage-list
            [attr.data-e2e]="elementsSelector.name.listSelectLocalOrCloud"
            [disableRowTooltip]="isConsistencyCheck ? whereBackupStepLogic.disabledRowText : ''"
            [id]="elementsSelector.id.listLocalOrCloudStorages"
            [invalid]="isNotValidFirstTable && stepForm.get('ConnectionID').touched"
            [maxHeight]="secondTableMaxHeight"
            [selectedStorages]="whereBackupStepLogic.selectedMixStorages"
            [storages]="whereBackupStepLogic.MixStorages"
            (changeSelected)="changeSelectedHandler($event)"
            (rowClick)="clickHandler()"></mbs-where-backup-step-storage-list>
        </mbs-form-group>
      }

      @if (stepForm.get('IsHybridBackup').value && whereBackupStepLogic.canBeHybrid) {
        <mbs-form-group>
          <div class="mbs-form_label">
            {{ 'wizards:local_storage' | i18next }}
          </div>

          @if (whereBackupStepLogic.LocalStorages.length === 0) {
            <ng-container>
              <mbs-alert
                class="mt-3"
                [attr.data-e2e]="elementsSelector.name.notLocalStorageAlert"
                [icon]="true"
                [type]="mbsPopupType.warning">
                {{ 'wizards:not_local_storage' | i18next }} <br />
                {{ whereBackupStepLogic.notLocalStorageTexts[0] }}
                <mbs-button
                  [isCtrl]="true"
                  (click)="whereBackupStepLogic.switchToLocalOrCloudOption($event)">
                  {{ whereBackupStepLogic.notLocalStorageTexts[1] }}
                </mbs-button>
                {{ whereBackupStepLogic.notLocalStorageTexts[2] }}
              </mbs-alert>
            </ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="localStorageTable"></ng-container>
          }

          <ng-template #localStorageTable>
            <mbs-where-backup-step-storage-list
              [attr.data-e2e]="elementsSelector.name.listSelectLocal"
              [id]="elementsSelector.id.listLocalStorages"
              [invalid]="isNotValidHybridTable && stepForm.get('HybridID').touched"
              [maxHeight]="'193px'"
              [selectedStorages]="whereBackupStepLogic.selectedLocalStorages"
              [storages]="whereBackupStepLogic.LocalStorages"
              (changeSelected)="changeSelectedHandler($event, false)"
              (rowClick)="clickHandler()"></mbs-where-backup-step-storage-list>
          </ng-template>
        </mbs-form-group>
      }
    }

    @if ((isNBF || isSQLPlan) && ability.can('read', 'HelpMarketing')) {
      <ng-container>
        <mbs-alert
          class="mb-0 mt-3"
          [attr.data-e2e]="elementsSelector.name.needNewStorageAlert"
          [icon]="true"
          [type]="mbsPopupType.info">
          {{ 'wizards:whereBackup.where_backup_need_new_storage' | i18next }}
          @if (createDestinationService && (mainService.hid || isRDMode)) {
            <mbs-button
              [isCtrl]="true"
              [loading]="creatingDestination"
              (click)="createDestination()">
              {{ 'shared:buttons.clickHere' | i18next }}
            </mbs-button>
          } @else {
            <a
              target="_blank"
              [href]="routingPath.ApStorages + '/addNew'">
              {{ 'shared:buttons.clickHere' | i18next }}
            </a>
          }
        </mbs-alert>
      </ng-container>
    }
  </div>
</section>
